import { Report195Container } from "../../../containers/borrowSystem/Report/Report195Container";

export function Report195Page() {
    return (
        <Report195Container />
    )
}